<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TimelineMax as Line, Power1 } from 'gsap'

import Widget from '@/components/widget'
import BaseButton from '@/components/base-button'

export default {

  name: 'awards-widget',

  mixins: [Widget],

  components: {
    BaseButton
  },

  data () {
    return {
      tl: null
    }
  },

  filters: {
    getYear: timestamp => new Date(timestamp).getFullYear()
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })

      tl.from(this.$refs.background, 1, {
        scaleX: 0,
        ease: Power1.easeOut
      })

      const group = [this.$refs.title]

      if (this.$refs.items) group.push(...this.$refs.items)

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      }, 0.05, '-=0.25')
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.awards
  .awards__container

    .awards__background(ref="background")

    .awards__wrapper.content
      .content__header(ref="title") {{ $content.title }}

      .content__main.list
        .list__item.item(v-for="award in $content.items" ref="items")

          .item-hgroup
            .item-hgroup__heading {{ award.title }}
            .item-hgroup__label {{ award.date | getYear }}
          .item-content
            p.item-content__text {{ award.description }}
          .item-actions
            base-button.item-actions__button(:label="$t('launch-site')", :url="award.url", :white="true")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.awards
  position relative
  padding-top 80px
  padding-left 65px
  padding-bottom 80px
  color white

  +laptop()
    padding-left 26px

  +tablet()
    padding-left 50px

  +mobile()
    padding-left 13px

  &__container
    position relative
    display flex
    justify-content center
    width 100%
    padding-top 116px
    padding-bottom 65px
    padding-right 65px

    +laptop()
      padding-left 79px

    +tablet()
      padding 90px 50px

    +mobile()
      padding 75px 24px 65px 40px

  &__background
    z-index 1
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color blue
    transform-origin right

  &__wrapper
    z-index 2
    position relative
    max-width 1008px
    width 100%
    // padding-right 114px // 96px + 18px

    +hd()
      max-width: 1260px;
      padding-left: 60px;
      padding-right: 0;

.content

  &__header
    font-weight 400
    font-size 56px
    line-height 57px

    +mobile()
      font-size 46px
      line-height 50px

  &__header + &__main
    margin-top 50px

    +mobile()
      margin-top 30px

.list
  display flex
  flex-direction column
  list-style none
  counter-reset items

  // &__item

.item
  position relative
  display flex
  flex-direction row
  padding-top 30px
  padding-left 40px
  padding-bottom 37px

  &:before
    counter-increment items
    content counter(items)
    position absolute
    top 30px
    left 0
    font-weight 300
    font-size 16px
    line-height 23px

  &:not(:last-child):after
    content ''
    position absolute
    right 0
    bottom 0
    display block
    width calc(100% - 40px)
    height 1px
    background-color #fff
    opacity 0.25

    +mobile()
      width calc(100% - 24px)

  +mobile()
    flex-direction column
    padding 30px 0 30px 24px

.item-hgroup
  flex 0 0 auto
  display flex
  flex-direction column
  width 285px
  padding-left 18px

  +tablet()
    padding-left 0
    width 200px

  +mobile()
    margin-bottom 20px
    width 100%
    padding 0

  &__heading
    font-weight 500
    font-size 16px
    line-height 23px

    & + *
      margin-top 18px

  &__label
    font-size 12px
    line-height 11px

.item-content
  flex 1 0 auto
  width 500px
  max-width 40%
  padding-left 18px
  padding-right 18px

  +hd()
    max-width 55%

  +mobile()
    margin-bottom 30px
    max-width 100%
    padding 0

  &__text
    font-size 14px
    line-height 23px

.item-actions
  flex 0 0 auto
  display flex
  margin-left auto

  +mobile()
    margin-left 0

  &__button
    margin-top -5px
    color white

</style>



// WEBPACK FOOTER //
// awards.vue?22b8f076